module.exports = "https://static.wagwalking.com/_next/static/images/become-a-walker-background-desktop-c1a61bd5fdee1b976efaeb24e1a35bed.jpg";